import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconMenuNotification$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconMenuNotification extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '0248b620e0dd17d0593f9f21100b429cb0c27121', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '0f65c9d5aec2045725d5218a23e034e1ce24e411', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'b8aa502dce367372a5f0130ad8eb4649473a2476', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M3.5 4a.5.5 0 0 0-.5.5V5a.5.5 0 0 0 .5.5h15A.5.5 0 0 0 19 5v-.5a.5.5 0 0 0-.5-.5zm0 5.25a.5.5 0 0 0-.5.5v.5a.5.5 0 0 0 .5.5h4a.5.5 0 0 0 .5-.5v-.5a.5.5 0 0 0-.5-.5zM3 15a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 .5.5v.5a.5.5 0 0 1-.5.5h-4a.5.5 0 0 1-.5-.5zm7-1a5 5 0 1 1 10 0 5 5 0 0 1-10 0m4.75.5a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 1 .5-.5h.5a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5zm-.75 2a1 1 0 1 0 2 0 1 1 0 0 0-2 0", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-menu-notification", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-menu-notification"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-menu-notification":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconMenuNotification$1);
            }
            break;
    } });
}

const CosmosIconMenuNotification = CosmosIconMenuNotification$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconMenuNotification, defineCustomElement };
